import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from "react";
import "./TopBar.css";
import { DebugLog } from "../HelperFunctions";
import LocalStorageKeys from "../classes/LocalStorageKeys";
import { useHotkeys } from "react-hotkeys-hook";
import { version } from "../PackageImport";
export const TopBarView = (props) => {
    var _a, _b;
    useHotkeys("ctrl+shift+z", () => {
        ShowVersionNumber();
    });
    const isSetupComplete = useRef(false);
    const isChildButtonDown = useRef(false);
    const versionNumberRef = useRef(version);
    const displayString = props.DisplayText === undefined ? "" : props.DisplayText;
    const topBarRootID = props.BarSelect === 0 ? "topBarRoot_Intro" : "topBarRoot";
    const topBarID = props.BarSelect === 0
        ? "defaultTopBarHolder"
        : props.BarSelect === 1
            ? "selectTopBarHolder"
            : "vertSelectTopBarHolder";
    let barAnimClass = props.SetToHide && props.BarSelect >= 1
        ? "outroTopBar"
        : !props.SetToHide && props.BarSelect >= 1
            ? "introTopBar"
            : "";
    // adjust class if series or package
    const adjustment = props.BarSelect === 2 ? "_Series" : props.BarSelect === 3 ? "_Package" : "";
    barAnimClass = barAnimClass + adjustment;
    const [textHideClass, setTextHideClass] = useState("hideWhileCollapsed");
    const loginState = {
        USER: "Customer Portal",
        CONCIERGE: "Concierge Team",
    };
    const currentLoginState = useRef(loginState.USER);
    const [loginStateText, setLoginStateText] = useState(currentLoginState.current);
    let toolState;
    (function (toolState) {
        toolState["HIDE"] = "1";
        toolState["PARTIAL"] = "2";
        toolState["FULL"] = "3";
    })(toolState || (toolState = {}));
    const currentToolState = useRef(toolState.HIDE);
    const [showButton, setShowButton] = useState(false);
    const topRightElem = useRef(document.getElementById("topRightCornerBarImg"));
    const topButtonElem = useRef((_a = topRightElem.current) === null || _a === void 0 ? void 0 : _a.children[0]);
    const botButtonElem = useRef((_b = topRightElem.current) === null || _b === void 0 ? void 0 : _b.children[1]);
    const selectText = "SELECT " + displayString;
    let blurTimeoutRef;
    const ShowVersionNumber = () => {
        const topLeftElem = document.getElementById("topLeftCornerBarImg");
        const versionSpan = document.getElementById("versionSpan");
        if (!topLeftElem || !versionSpan) {
            DebugLog("Could not find version element(s)");
            return;
        }
        topLeftElem.setAttribute("class", "topLeftShow");
        versionSpan.setAttribute("class", "versionShow");
        DebugLog("!!Showing");
    };
    setTimeout(() => {
        setupTopRightDrawer();
    }, 100);
    const updateToolState = (newState) => {
        currentToolState.current = newState;
        if (newState === toolState.FULL) {
            setShowButton(true);
        }
        else {
            setShowButton(false);
        }
        if (newState === toolState.HIDE) {
            setTextHideClass("hideWhileCollapsed");
        }
        else {
            setTextHideClass("exposeWhileNotCollapsed");
        }
    };
    const closeToolStateUI = () => {
        var _a;
        if (topButtonElem.current === document.activeElement) {
            return;
        }
        (_a = topRightElem.current) === null || _a === void 0 ? void 0 : _a.setAttribute("class", "topRightClose");
        if (currentToolState.current === toolState.PARTIAL ||
            currentToolState.current === toolState.FULL) {
            updateToolState(toolState.HIDE);
        }
    };
    const peekToolStateUI = (setFocus = true) => {
        var _a, _b;
        if (currentToolState.current !== toolState.PARTIAL) {
            (_a = topRightElem.current) === null || _a === void 0 ? void 0 : _a.setAttribute("class", "topRightHover");
            updateToolState(toolState.PARTIAL);
            if (setFocus)
                (_b = topRightElem.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    // setup mouse actions on div container for top-right login-type tool
    const setupTopRightDrawer = () => {
        var _a, _b, _c, _d, _e;
        if (props.BarSelect === 0 && !isSetupComplete.current) {
            // setup hover
            if (topRightElem.current === null) {
                topRightElem.current = document.getElementById("topRightCornerBarImg");
            }
            if (topButtonElem.current === null) {
                topButtonElem.current = (_a = topRightElem.current) === null || _a === void 0 ? void 0 : _a.children[0];
            }
            if (botButtonElem.current === null) {
                botButtonElem.current = (_b = topRightElem.current) === null || _b === void 0 ? void 0 : _b.children[0];
            }
            (_c = topRightElem.current) === null || _c === void 0 ? void 0 : _c.addEventListener("mouseenter", () => {
                if (currentToolState.current === toolState.HIDE)
                    peekToolStateUI();
            });
            (_d = topRightElem.current) === null || _d === void 0 ? void 0 : _d.addEventListener("blur", (event) => {
                if (isChildButtonDown.current)
                    return;
                if (blurTimeoutRef !== null) {
                    clearTimeout(blurTimeoutRef);
                }
                blurTimeoutRef = setTimeout(() => {
                    if (currentLoginState.current === loginState.USER &&
                        currentToolState.current !== toolState.HIDE) {
                        closeToolStateUI();
                    }
                    else if (currentLoginState.current === loginState.CONCIERGE &&
                        currentLoginState.current !== toolState.PARTIAL) {
                        peekToolStateUI();
                    }
                }, 100);
            });
            (_e = topRightElem.current) === null || _e === void 0 ? void 0 : _e.addEventListener("click", () => {
                var _a;
                (_a = topRightElem.current) === null || _a === void 0 ? void 0 : _a.setAttribute("class", "topRightClick");
                updateToolState(toolState.FULL);
            });
            isSetupComplete.current = true;
        }
    };
    const UpdateLoginTypeSelection = () => {
        isChildButtonDown.current = false;
        if (blurTimeoutRef !== null) {
            clearTimeout(blurTimeoutRef);
        }
        if (currentLoginState.current === loginState.USER) {
            currentLoginState.current = loginState.CONCIERGE;
            localStorage.setItem(LocalStorageKeys.loginType, "concierge");
            peekToolStateUI();
        }
        else {
            currentLoginState.current = loginState.USER;
            localStorage.setItem(LocalStorageKeys.loginType, "user");
            closeToolStateUI();
        }
        if (currentLoginState.current !== loginStateText) {
            setLoginStateText(currentLoginState.current);
        }
    };
    const notChangeSelection = () => {
        isChildButtonDown.current = false;
        if (blurTimeoutRef !== null) {
            clearTimeout(blurTimeoutRef);
        }
        if (currentLoginState.current === loginState.USER) {
            closeToolStateUI();
        }
        else {
            peekToolStateUI();
        }
    };
    const childButtonDown = () => {
        isChildButtonDown.current = true;
    };
    return (_jsx("div", Object.assign({ id: topBarRootID }, { children: _jsx("div", Object.assign({ id: "topBarRatio" }, { children: _jsxs("div", Object.assign({ id: topBarID, className: barAnimClass }, { children: [props.BarSelect === 0 && (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ id: "versionSpan", className: "versionHide" }, { children: versionNumberRef.current })), _jsx("img", { id: "topLeftCornerBarImg", className: "topLeftClosed", src: "./Images/Misc/TopCornerBar.png", alt: "Top Bar" })] })), props.BarSelect === 0 && (_jsxs("div", Object.assign({ id: "topRightCornerBarImg", className: "topRightClose", "aria-label": "LoginTypeMenu", tabIndex: -1 }, { children: [_jsx("button", Object.assign({ id: "loginTypeToggleButton", onMouseDown: childButtonDown, onClick: UpdateLoginTypeSelection }, { children: _jsx("span", { children: loginStateText === loginState.CONCIERGE
                                        ? loginState.USER
                                        : loginState.CONCIERGE }) })), showButton && (_jsx("button", Object.assign({ id: "loginTypeToggleButton", onMouseDown: childButtonDown, onClick: notChangeSelection }, { children: _jsx("span", Object.assign({ id: "testy1" }, { children: loginStateText === loginState.CONCIERGE
                                        ? loginState.CONCIERGE
                                        : loginState.USER })) }))), !showButton && (_jsx("span", Object.assign({ id: "currentLoginTypeSpan", className: textHideClass }, { children: loginStateText })))] }))), props.BarSelect === 1 && (_jsx("img", { id: "selectionTopBarImg", src: "./Images/Misc/TopBar_Selection.png", alt: "Top Bar" })), props.BarSelect >= 2 && (_jsx("div", Object.assign({ id: "vertSelectionTopBar" }, { children: _jsx("span", { children: selectText }) }))), displayString !== "" && props.BarSelect < 2 && (_jsxs("h1", Object.assign({ id: "topBarText" }, { children: [_jsx("span", Object.assign({ style: { color: "white" } }, { children: "Select" })), " ", _jsx("span", Object.assign({ style: { color: "red" } }, { children: displayString }))] })))] })) })) })));
};
